export enum SettingsSdkKeys {
    Direction = "next.ecommerce.direction",
    Realm = "next.ecommerce.realmName",
    Territory = "next.ecommerce.territoryName",
    Language = "next.ecommerce.languageName",
    CorrelationHeaderName = "x-next-correlation-id",
    AppCache = "next.ecommerce.plp.frontend.appCacheTTL",
    // This is used in middleware where the value is lowercase. Please don't change this back
    textData = "next.ecommerce.plp.frontend.textData",
    // PBI 417564 - To be removed once using @next/themes & @next/theme-provider is retired.
    ThemeVersion = "next.ecommerce.plp.frontend.themeVersion",
    DebounceTime = "next.ecommerce.plp.frontend.debounceTime",
    SeoFilters = "next.ecommerce.plp.frontend.seoFilters",
    FeatureSwitch = "next.ecommerce.plp.frontend.featureSwitch",
    SingleOptionFacetList = "next.ecommerce.plp.frontend.singleOptionFacetList",
    FreeTextFiltersList = "next.ecommerce.plp.frontend.freeTextFiltersList",
    SingleFacetFiltersToBePreservedInTheUrl = "next.ecommerce.plp.frontend.singleFacetFiltersToBePreservedInTheUrl",
    TerritoryDescription = "next.ecommerce.plp.frontend.territoryDescription",
    InPageFilters = "next.ecommerce.plp.frontend.inPageFilters",
    FetchTriggerOffset = "next.ecommerce.plp.frontend.fetchTriggerOffset",
    FetchTriggerOffsetRows = "next.ecommerce.plp.frontend.fetchTriggerOffsetRows",
    SubsequentPagesNonLazyloadRows = "next.ecommerce.plp.frontend.subsequentPagesNonLazyloadRows",
    HideSearchFilterModalElements = "next.ecommerce.plp.frontend.hideSearchFilterModalElements",
    SearchBannersAppCache = "next.ecommerce.plp.frontend.searchBannerAppCacheTTL",
    BloomreachPersonalizationCookies = "next.ecommerce.plp.frontend.bloomreachPersonalizationCookies",
    addNoIndexToCategoryFilterUrls = "next.ecommerce.plp.frontend.addNoIndexToCategoryFilterUrls",
    EnableJquery = "next.ecommerce.plp.frontend.enableJquery",
    InjectedAdsConfig = "next.ecommerce.plp.frontend.injectedAds",
    PageSizeLimit = "next.ecommerce.plp.frontend.pageSizeLimit",
    SetBloomreachSegmentToUnclassifiedIfNotPresent = "next.ecommerce.plp.frontend.setBloomreachSegmentToUnclassifiedIfNotPresent",
    RememberFilters = "next.ecommerce.plp.frontend.rememberFilters",
    HideFooterUntilLastPage = "next.ecommerce.plp.frontend.hideFooterUntilLastPage",
    DisableFooter = "next.ecommerce.plp.frontend.disableFooter",
    EnableStaticEsiEndpoint = "next.ecommerce.plp.frontend.enableStaticEsiEndpoint",
    ProductLoadTrigger = "next.ecommerce.plp.frontend.productLoadTrigger",
    EnableCentreTitle = "next.ecommerce.plp.frontend.enableCentreTitle",
    DisableIcons = "next.ecommerce.plp.frontend.disableIcons",
    showRealmInTopFiveBrands = "next.ecommerce.plp.frontend.showRealmInTopFiveBrands",
    lazyLoadFilterFacetsInHorizontalFilters = "next.ecommerce.plp.frontend.lazyLoadFilterFacetsInHorizontalFilters",
    AlphabticallySortedFacetsInHorizontalFilters = "next.ecommerce.plp.frontend.alphabticallySortedFacetsInHorizontalFilters",
    EnableFontsPreload = "next.ecommerce.plp.frontend.enableFontsPreload",
    imageCdnUrl = "next.ecommerce.productsummary.frontend.imageCdnUrl",
    appCache = "next.ecommerce.productsummary.frontend.appCacheTTL",
    cacheControl = "next.ecommerce.productsummary.frontend.cache-control.max-age",
    cacheControlForColourwaysApi = "next.ecommerce.productsummary.frontend.cache-control.max-age.colourways-api",
    cacheControlDefault = "next.ecommerce.productsummary.frontend.cache-control.default-productsummary.max-age",
    lazyLoadConfig = "next.ecommerce.productsummary.frontend.lazyloadConfig",
    enableSearchDescription = "next.ecommerce.productsummary.frontend.enableSearchDescription",
    enableCenteredContent = "next.ecommerce.productsummary.frontend.enableCenteredContent",
    mobileThumbnailConfig = "next.ecommerce.productsummary.frontend.mobileThumbnailConfig",
    lazySizesConfig = "next.ecommerce.productsummary.frontend.lazySizesConfig",
    maxNumberOfSofaColourways = "next.ecommerce.productsummary.frontend.maxNumberOfSofaColourways",
    maxNumberOfHomewareColourways = "next.ecommerce.productsummary.frontend.maxNumberOfHomewareColourways",
    brandedMarkdownSalePrice = "next.ecommerce.productsummary.frontend.brandedMarkdownSalePrice",
    displayFitIcons = "next.ecommerce.productsummary.frontend.displayFitIcons",
    displayNewIn = "next.ecommerce.productsummary.frontend.displayNewIn",
    StructuredBrowsingChipsToLoadLimit = "next.ecommerce.plp.frontend.structuredBrowsingChipsToLoadLimit",
    CompositeFiltersList = "next.ecommerce.plp.frontend.compositeFiltersList",
    ShowCategoryThumbnails = "next.ecommerce.plp.frontend.showCategoryThumbnails",
    EnableSearchBannerTemplating = "next.ecommerce.plp.frontend.enableSearchBannerTemplating",
    PriceSelectorIncrement = "next.ecommerce.plp.frontend.priceSelectorIncrement",
    ApiProxyVersion = "next.ecommerce.plp.frontend.apiProxyVersion",
    BloomreachDefaultProviderArgs = "next.ecommerce.plp.frontend.bloomreachDefaultProviderArgs",
    EnableSingleLineBrandName = "next.ecommerce.productsummary.frontend.enableSingleLineBrandName",
    RemoveBrandNameInTitle = "next.ecommerce.productsummary.frontend.removeBrandNameInTitle",
    EdgeAggregator = "next.ecommerce.plp.frontend.edgeAggregator",
}

export interface SettingsModel {
    realm: string
    territory: string
    language: string
}
